import './styles.css';
import { buildHomePageMarkup } from './site-content';

const app = document.querySelector<HTMLElement>('#app');

if (!app) {
  throw new Error('App root element was not found.');
}

app.innerHTML = buildHomePageMarkup(import.meta.env.VITE_CHECKOUT_URL);
